import { render, staticRenderFns } from "./upsertPartnerSports.vue?vue&type=template&id=090c205e&lang=pug&"
import script from "./upsertPartnerSports.vue?vue&type=script&lang=js&"
export * from "./upsertPartnerSports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports